import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import { isString, get } from 'lodash';

import Icon from 'vibo-ui/Icon';

import { notificationIconByType } from './contstants';

import { NotificationIconProps } from './interface';

import useStyles from './style';

const NotificationIcon: FC<NotificationIconProps> = ({ notificationType }) => {
  const classes = useStyles();

  const icon = useMemo(() => get(notificationIconByType, notificationType), [notificationType]);

  const isFontIcon = useMemo(() => isString(icon), [notificationType]);

  return icon ? (
    <Icon
      className={classNames('notificationIcon', classes.notificationIcon, notificationType)}
      icon={icon}
      disableAutoFontSize={!isFontIcon}
    />
  ) : null;
};

export default NotificationIcon;
